import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@examdojo/core/environment';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HealthCheckHttpService {
  constructor(private readonly http: HttpClient) {}

  /**
   * Check if the API is healthy
   * Redirects to error page if unhealthy
   */
  checkHealth(): Observable<boolean> {
    return this.http.get(environment.examdojo.healthApiUrl).pipe(
      map(() => true),
      catchError(() => of(false)),
    );
  }
}
